import mailboxAxios from "../utils/mailboxAxios";

export const hrApi = {
  getDashboard: () => mailboxAxios.get("/hr/dashboard"),

  getPeople: (params = {}) => mailboxAxios.get("/hr/people", { params }),
  getPersonById: (id) => mailboxAxios.get(`/hr/people/${id}`),
  createPerson: (payload) => mailboxAxios.post("/hr/people", payload),
  updatePerson: (id, payload) => mailboxAxios.put(`/hr/people/${id}`, payload),
  archivePerson: (id) => mailboxAxios.put(`/hr/people/${id}/archive`),

  getDepartments: () => mailboxAxios.get("/hr/departments"),
  createDepartment: (payload) => mailboxAxios.post("/hr/departments", payload),
  updateDepartment: (id, payload) => mailboxAxios.put(`/hr/departments/${id}`, payload),

  getTeams: (params = {}) => mailboxAxios.get("/hr/teams", { params }),
  createTeam: (payload) => mailboxAxios.post("/hr/teams", payload),
  updateTeam: (id, payload) => mailboxAxios.put(`/hr/teams/${id}`, payload),

  getPositions: (params = {}) => mailboxAxios.get("/hr/positions", { params }),
  createPosition: (payload) => mailboxAxios.post("/hr/positions", payload),
  updatePosition: (id, payload) => mailboxAxios.put(`/hr/positions/${id}`, payload),

  getEmploymentByPersonId: (id) => mailboxAxios.get(`/hr/people/${id}/employment`),
  createEmployment: (payload) => mailboxAxios.post("/hr/employment", payload),
  updateEmployment: (id, payload) => mailboxAxios.put(`/hr/employment/${id}`, payload),
  closeEmployment: (id, payload) => mailboxAxios.post(`/hr/employment/${id}/close`, payload),

  getNotesByPersonId: (id) => mailboxAxios.get(`/hr/people/${id}/notes`),
  createNote: (payload) => mailboxAxios.post("/hr/notes", payload),
  updateNote: (id, payload) => mailboxAxios.put(`/hr/notes/${id}`, payload),

  getDocumentsByPersonId: (id) => mailboxAxios.get(`/hr/people/${id}/documents`),
  createDocument: (payload) => mailboxAxios.post("/hr/documents", payload),
  updateDocument: (id, payload) => mailboxAxios.put(`/hr/documents/${id}`, payload),

  uploadDocumentFile: (formData) => mailboxAxios.post("/hr/documents/upload", formData, {headers: { "Content-Type": "multipart/form-data" },}),

  getProjectResources: (projectId) => mailboxAxios.get(`/hr/projects/${projectId}/resources`),
  createProjectResource: (payload) => mailboxAxios.post("/hr/projects/resources", payload),
  updateProjectResource: (id, payload) => mailboxAxios.put(`/hr/projects/resources/${id}`, payload),
  deleteProjectResource: (id) => mailboxAxios.delete(`/hr/projects/resources/${id}`),

  getOrgChart: () => mailboxAxios.get("/hr/org-chart"),

  getPositionAssignments: (positionId) => mailboxAxios.get(`/hr/positions/${positionId}/assignments`),
  createPositionAssignment: (payload) => mailboxAxios.post("/hr/positions/assignments", payload),
  closePositionAssignment: (id) => mailboxAxios.patch(`/hr/positions/assignments/${id}/close`),

  getPositionRoles: (positionId) => mailboxAxios.get(`/hr/positions/${positionId}/roles`),
  createPositionRole: (payload) => mailboxAxios.post("/hr/positions/roles", payload),
  updatePositionRole: (id, payload) => mailboxAxios.put(`/hr/positions/roles/${id}`, payload),
  deletePositionRole: (id) => mailboxAxios.delete(`/hr/positions/roles/${id}`),

  searchSystemUsers: (q) => mailboxAxios.get("/hr/system-users/search", { params: { q } }),
  autoLinkPersonUser: (id) => mailboxAxios.post(`/hr/people/${id}/auto-link-user`),
  linkPersonUser: (id, payload) => mailboxAxios.put(`/hr/people/${id}/link-user`, payload),
  unlinkPersonUser: (id) => mailboxAxios.delete(`/hr/people/${id}/link-user`)

};